// this function expects each param to be from Date.now()
export const timeStampMinutesDifference = (time1, time2) => {
  const difference = time1 - time2;
  const minutesDifference = Math.floor(difference / 1000 / 60);

  return minutesDifference;
};
